import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Table as AntTable, Button, Space, message } from 'antd'
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import moment from 'moment'
import { Wrapper, Actions, StyledButton } from './ArcAdvertisers.styles'
import SearchInTableBar from 'components/SearchInTableBar'
import useAction from 'utils/useAction'
import { selectors as arcAdvertisersSelectors } from 'domains/arcAdvertisers'
import * as actions from 'actions/views/arcAdvertisers'
import { formatArcAdvertiserForTable } from 'domains/arcAdvertisers/formatters'
import {
  openConfirmModal,
  openArcAdvertiserModal,
} from 'reducers/modals/actions'
import { FIELD_NAMES } from 'const/forms'
import { getColumns } from './columns'

const ArcAdvertisers = () => {
  const [filters, setFilters] = useState({})
  const [sorter, setSorter] = useState({})
  const [search, setSearch] = useState('')
  const advertisers = useSelector(arcAdvertisersSelectors.getArcAdvertisers)
  const isLoaded = useSelector(arcAdvertisersSelectors.getIsLoaded)
  const page = useSelector(arcAdvertisersSelectors.getPage)
  const pageCount = useSelector(arcAdvertisersSelectors.getPageCount)
  const searchString = useSelector(arcAdvertisersSelectors.getSearchString)
  const isSaving = useSelector(arcAdvertisersSelectors.getIsSavingActive)
  const isFiltered = useSelector(arcAdvertisersSelectors.getIsDataFilteredOrSorted)
  const fetchAdvertisers = useAction(actions.fetchArcAdvertisers)
  const deleteAdvertiser = useAction(actions.deleteArcAdvertiser)
  const resetFilters = useAction(actions.resetFiltersAndSorter)
  const openConfirmModalFunc = useAction(openConfirmModal)
  const openArcAdvertiserModalFunc = useAction(openArcAdvertiserModal)

  useEffect(() => {
    fetchAdvertisers({ page: 1, search: '', filters: {}, sorter: {} })
  }, [fetchAdvertisers])

  const handleTableChange = (pagination, tableFilters, tableSorter) => {
    const newPage = pagination.current
    const newFilters = tableFilters

    setFilters(newFilters)
    fetchAdvertisers({
      page: newPage,
      search: searchString,
      filters: newFilters,
      sorter: {sort: 'created_at'}
    })
  }

  const handleCreateAdvertiser = () => {
    openArcAdvertiserModalFunc()
  }

  const handleEditAdvertiser = (advertiser) => {
    openArcAdvertiserModalFunc(advertiser)
  }

  const handleResetFilters = () => {
    setFilters({})
    setSorter({})
    setSearch('')
    resetFilters()
    fetchAdvertisers({ page: 1, search: '', filters: {}, sorter: {} })
  }
  const dataSource = advertisers.map(advertiser => formatArcAdvertiserForTable(advertiser))

  return (
    <Wrapper>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1>Arc Advertisers</h1>
        <Space>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreateAdvertiser}
            disabled={!isLoaded}
          >
            Create Advertiser
          </Button>
          <Button
            onClick={handleResetFilters}
            disabled={!isFiltered}
          >
            Reset Filters
          </Button>
        </Space>
      </div>

      <AntTable
        columns={getColumns(handleEditAdvertiser)}
        dataSource={dataSource}
        rowKey="id"
        loading={!isLoaded || isSaving}
        onChange={handleTableChange}
        pagination={{
          current: page,
          total: pageCount * 20,
          pageSize: 20,
          showQuickJumper: true,
          showSizeChanger: false,
          position: ['bottomCenter'],
        }}
        scroll={{ x: 800 }}
        size="middle"
        bordered
      />
    </Wrapper>
  )
}

export default ArcAdvertisers